import { getSelectOptions } from 'utils/getSelectOptions';

export const getUsersOptions = users =>
  getSelectOptions(users, 'id', userLabel => userLabel.username);
